import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { IChargingMethodService } from '../entities/IChargingMethodService';
import { IChargingMethodRepository } from '../entities/IChargingMethodRepository';
import { ChargingMethod } from '../entities';

export class ChargingMethodServiceImpl implements IChargingMethodService {
  itemRepo: IChargingMethodRepository;

  constructor(ir: IChargingMethodRepository) {
    this.itemRepo = ir;
    this.GetChargingMethods = this.GetChargingMethods.bind(this);
  }

  GetChargingMethods(data?: GenericObject): Promise<ChargingMethod[]> {
    return this.itemRepo.GetChargingMethods(data);
  }
}
